/**
 * Configuration Firebase Web (Cloud Messaging / Web Push).
 *
 * Ce sont des valeurs **publiques** côté client (comme pour tout SDK Firebase Web) — elles ne sont
 * pas des secrets et n'ont pas besoin de passer par des variables d'environnement. Le même projet
 * Firebase que les push natifs iOS/Android (cf. `docs/PWA_PUSH_NOTIFICATIONS.md`).
 *
 * Dupliqué tel quel dans `public/firebase-messaging-sw.js` : le service worker ne peut pas importer
 * ce module (chargé hors bundle Vite, avant que l'app existe), donc les deux copies doivent rester
 * synchronisées si ces valeurs changent un jour.
 */
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyA_EnBXmyf68vtz53xxpA3woWhduj89R24",
  authDomain: "successchool-3a271.firebaseapp.com",
  projectId: "successchool-3a271",
  storageBucket: "successchool-3a271.firebasestorage.app",
  messagingSenderId: "419096586592",
  appId: "1:419096586592:web:8ed5cb75a446a54baa1605",
} as const;

/** Clé publique VAPID (Web Push certificate) — Firebase Console → Cloud Messaging. */
export const FIREBASE_VAPID_KEY =
  "BNMbnU1veRazA83jZe6Z9D1PcT-tI0u8o0KnUBNEekx7O-RnnSOlSNEy-rN_ZUOp1t7BHfAhWIACd_eZ3BqGRDk";
